// Turks (tr-TR), virtualDevice: zelfde vorm als virtualDevice.nl.ts (golf 3-integratie).
export const appVirtualDeviceTr = {
    title: 'Sanal iPad',
    intro: 'Gerçek aile panosu, tam duvardaki tablette olduğu gibi.',
    entry: 'Sanal iPad',
    entryBody: 'Tarayıcında pano, bakmak ve denemek için.',
    orientation: 'Yön',
    landscape: 'Yatay',
    portrait: 'Dikey',
    zoom: 'Boyut',
    fit: 'Sığdır',
    actual: '100%',
    profile: 'Tablet',
    roomEveryone: '{room}, herkes',
    roomMembers: '{room}, {names}',
    ownWindow: 'Ayrı pencere',
    ownWindowLabel: 'Sanal iPad’i 1024 x 768 boyutunda ayrı bir pencerede aç',
    pairTitle: 'Bu sanal iPad’i bağla',
    pairBody: 'Ailende ayrı bir tablet olur. Sonra onu Tabletler bölümünde bulursun ve orada bağlantısını kesebilirsin.',
    pairButton: 'Bağla',
    pairWaiting: 'Pano bir eşleştirme kodu oluşturuyor…',
    pairedToast: 'Sanal iPad bağlandı',
    status: '{name}, {room}',
    moved: 'Pano şimdi {room} tabletini gösteriyor',
    revoke: 'Bağlantıyı kes',
    revokeTitle: 'Sanal iPad’in bağlantısı kesilsin mi?',
    revokeBody: 'Tarayıcındaki pano sonra yeniden bir eşleştirme kodu gösterir. Gerçek tabletlerin bundan etkilenmez.',
    revoked: 'Sanal iPad’in bağlantısı kesildi',
    hint: 'Her tıklama bir dokunuştur. Ses ve sesli okuma, panoya ilk tıklamandan sonra çalışır, iPad’de olduğu gibi.',
    storageTitle: 'Bu tarayıcı bağlantıyı sayfanın içinde tutmuyor',
    storageBody: 'Bazı tarayıcılar (çoğu zaman Safari) gömülü bir panoyu ayrı saklar. iPad’i ayrı bir pencerede aç: orada bağlı kalır.',
    popupBlocked: 'Tarayıcın pencereyi engelledi. Bu site için açılır pencerelere izin ver ve tekrar dene.',
    frameTitle: 'Sanal iPad’de aile panosu',
    foreignTitle: 'Bu pano {name} olarak bağlı, normal bir tablet',
    foreignBody: 'Panoyu daha önce bu tarayıcıda doğrudan açtın. Onu sanal iPad olarak yeniden bağla: o zaman {name} bağlantısı kesilir.',
    foreignButton: 'Sanal iPad olarak yeniden bağla',
    foreignOtherTitle: 'Bu pano başka bir aileye ait',
    foreignOtherBody: 'Bu tarayıcı başka bir ailenin tableti olarak bağlı. Orada Tabletler bölümünden bağlantısını kes veya bu sayfayı gizli pencerede aç.',
    foreignStatus: '{name}, {room} (normal tablet)',
    stuckTitle: 'Pano yanıt vermiyor',
    stuckBody: 'Panoyu yeniden yükle. Boş kalırsa ayrı bir pencerede aç.',
    stuckReload: 'Yeniden yükle',
    tag: 'Sanal',
    openOnDevice: 'Aç',
};
//# sourceMappingURL=virtualDevice.tr.js.map